import { useLocation } from "react-router-dom";

// React 19 hoists <title>/<meta>/<link> rendered here into <head>.
export const Seo = ({ title, description, path }) => {
  const location = useLocation();
  const pathname = path || location.pathname;
  let origin =
    typeof window !== "undefined" ? window.location.origin : "https://skilledshark.com";
  origin = origin.replace("://www.", "://");
  const canonical = `${origin}${pathname === "/" ? "" : pathname}`;

  return (
    <>
      <title>{title}</title>
      <meta name="description" content={description} />
      <link rel="canonical" href={canonical} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
    </>
  );
};

export default Seo;
